$.validator.setDefaults({
    ignore: [],
});

$(window).bind("load", function () {
    $(".loading-screen").fadeOut("slow");

    $(".loading-form").submit(function (e) {
        var formId = $(this).attr('id');
        if ($("#" + formId).valid()) {
            $("#" + formId + "-ajax-loader").show();
        }
    });

    $(".loading-form-no-recaptcha").submit(function (e) {
        var formId = $(this).attr('id');
        $("#" + formId + "-ajax-loader").show();
    });


    $(".ReCaptchaUtilSubmitButton").click(function (e) {
        e.preventDefault();
        var siteKey = $(this).attr('data-sitekey');
        var button = $(this);
        var form = $(this).closest('form');
        var formId = form.attr('id');
        button.attr('disabled', 'true');
        $('#' + formId + '-ajax-loader').show();

        grecaptcha.ready(function () {
            grecaptcha.execute(siteKey, { action: 'submit' }).then(function (token) {
                SetSpamData();
                $('.GoogleReCaptchaToken').val(token);
                form.submit();
                button.removeAttr('disabled');
                $('#' + formId + '-ajax-loader').hide();
            });
        });
    });
});

$(document).ready(function () {
    //resends the email verification
    $("#btnVerifyEmail").click(function () {
        SendVerifyEmail($(this).attr("data-value"));
    });

    //hack for the clickable link this activates only on desktop
    if (window.matchMedia('(min-width : 1224px)').matches) {
        $('.custom-menu-link').each(function (i, obj) {
            var clickable = $(this).attr("data-dropdown-clickable");
            var href = $(this).attr("data-href");
            if (clickable == "true") {
                $(this).attr("data-toggle", "");
                $(this).attr("href", href);
            }
        });
    }

    // Accessibility fix for Viostream modal focus
    // Accessibility fix for Viostream modal focus and scroll behaviour
    (function () {
        var viostreamLastFocusedElement = null;
        var viostreamLastOpenedModal = null;
        var viostreamScrollY = 0;
        var viostreamOriginalBodyStyles = {};

        function isViostreamModal(modal) {
            return modal && modal.classList && modal.classList.contains('viostream-modal');
        }

        function getModalTargetFromTrigger(trigger) {
            if (!trigger) {
                return null;
            }

            return trigger.getAttribute('data-bs-target') || trigger.getAttribute('href');
        }

        function lockBackgroundScroll() {
            viostreamScrollY = window.scrollY || document.documentElement.scrollTop || 0;

            viostreamOriginalBodyStyles = {
                position: document.body.style.position,
                top: document.body.style.top,
                left: document.body.style.left,
                right: document.body.style.right,
                width: document.body.style.width,
                overflow: document.body.style.overflow
            };

            document.body.style.position = 'fixed';
            document.body.style.top = '-' + viostreamScrollY + 'px';
            document.body.style.left = '0';
            document.body.style.right = '0';
            document.body.style.width = '100%';
            document.body.style.overflow = 'hidden';
        }

        function unlockBackgroundScroll() {
            document.body.style.position = viostreamOriginalBodyStyles.position || '';
            document.body.style.top = viostreamOriginalBodyStyles.top || '';
            document.body.style.left = viostreamOriginalBodyStyles.left || '';
            document.body.style.right = viostreamOriginalBodyStyles.right || '';
            document.body.style.width = viostreamOriginalBodyStyles.width || '';
            document.body.style.overflow = viostreamOriginalBodyStyles.overflow || '';

            window.scrollTo(0, viostreamScrollY);
        }

        function focusCloseButton(modal) {
            if (!isViostreamModal(modal)) {
                return;
            }

            var closeButton = modal.querySelector('.closeModal');

            if (!closeButton) {
                return;
            }

            closeButton.focus({ preventScroll: true });
        }

        function safeFocusCloseButton(modal) {
            if (!isViostreamModal(modal)) {
                return;
            }

            var activeElement = document.activeElement;

            // Do not steal focus if the user has already moved focus inside the modal.
            if (activeElement && modal.contains(activeElement) && activeElement !== modal) {
                return;
            }

            focusCloseButton(modal);
        }

        document.addEventListener('show.bs.modal', function (event) {
            var modal = event.target;

            if (!isViostreamModal(modal)) {
                return;
            }

            viostreamLastOpenedModal = modal;

            // Bootstrap provides the button/link that opened the modal here.
            if (event.relatedTarget) {
                viostreamLastFocusedElement = event.relatedTarget;
            } else {
                var activeElement = document.activeElement;

                if (activeElement && typeof activeElement.focus === 'function') {
                    var target = getModalTargetFromTrigger(activeElement);

                    if (target === '#' + modal.id) {
                        viostreamLastFocusedElement = activeElement;
                    }
                }
            }

            lockBackgroundScroll();
        });

        document.addEventListener('shown.bs.modal', function (event) {
            var modal = event.target;

            if (!isViostreamModal(modal)) {
                return;
            }

            // Focus the close button when the modal opens.
            focusCloseButton(modal);

            // Third-party video scripts may load slightly after the modal opens.
            // These are safe checks and will not steal focus if the user has already tabbed inside the modal.
            setTimeout(function () {
                safeFocusCloseButton(modal);
            }, 100);

            setTimeout(function () {
                safeFocusCloseButton(modal);
            }, 300);
        });

        document.addEventListener('hidden.bs.modal', function (event) {
            var modal = event.target;

            if (!isViostreamModal(modal)) {
                return;
            }

            unlockBackgroundScroll();

            if (
                viostreamLastFocusedElement &&
                document.body.contains(viostreamLastFocusedElement) &&
                typeof viostreamLastFocusedElement.focus === 'function'
            ) {
                viostreamLastFocusedElement.focus({ preventScroll: true });
            }

            viostreamLastOpenedModal = null;
        });
    })();

});

function SendVerifyEmail(emailEncrypted) {
    $("#VerifyEmail-ajax-loader").show();
    $("#VerifyEmail-Success").hide();
    $("#VerifyEmail-Error").hide();

    $.get("/umbraco/Api/SiteApi/SendEmailVerificationEmail?emailEncrypted=" + emailEncrypted, function (data) {
        $("#VerifyEmail-ajax-loader").html(data);

        if (data == true) {
            $("#VerifyEmail-Success").show();
            setTimeout(function () {
                $("#VerifyEmail-Success").fadeOut("slow");
            }, 1000);
        }
        else {
            $("#VerifyEmail-Error").show();
            setTimeout(function () {
                $("#VerifyEmail-Error").fadeOut("slow");
            }, 1000);
        }

        $("#VerifyEmail-ajax-loader").hide();
    });
}

function ReCaptchaUtilEnableButton() {
    SetSpamData();
    $(".ReCaptchaUtilEnableButton").removeAttr("disabled");
}

function SetSpamData() {
    var enable = $(".SpamEnableIpLookup").val();
    var endpoint = $(".SpamIpLookupEndpoint").val();
    var key = $(".SpamIpLookupApiKey").val();
    if (enable == "True") {
        $.getJSON(endpoint + key, function (data) {
            var lookupAddress = CryptoJS.enc.Base64.stringify(CryptoJS.enc.Utf8.parse(data.ip));
            var lookupContinent = CryptoJS.enc.Base64.stringify(CryptoJS.enc.Utf8.parse(data.continent));
            var lookupCountry = CryptoJS.enc.Base64.stringify(CryptoJS.enc.Utf8.parse(data.country));
            $(".LookupAddress").val(lookupAddress);
            $(".LookupContinent").val(lookupContinent);
            $(".LookupCountry").val(lookupCountry);
            console.log("Ip Address: " + data.ip);
            console.log("Continent: " + data.continent);
            console.log("Country: " + data.country);
        });
    }
}

function isTextSelected(input) {
    if (typeof input.selectionStart == "number") {
        return input.selectionStart == 0 && input.selectionEnd == input.value.length;
    } else if (typeof document.selection != "undefined") {
        input.focus();
        return document.selection.createRange().text == input.value;
    }
}

function GlobalSearch(url, keyword, type) {
    var redirectUrl = url;

    if (keyword != "") {
        redirectUrl = redirectUrl + "?keywords=" + keyword;
    }

    window.location.href = redirectUrl;
}


function getValidHttpUrl(value) {
    if (!value || typeof value !== "string") {
        return null;
    }

    const text = value.trim();

    try {
        const url = new URL(text);

        if (url.protocol === "http:" || url.protocol === "https:") {
            return url.href;
        }

        return null;
    } catch {
        return null;
    }
}

Handlebars.registerHelper("isUrl", function (value, options) {
    return getValidHttpUrl(value)
        ? options.fn(this)
        : options.inverse(this);
});

Handlebars.registerHelper("safeUrl", function (value) {
    return getValidHttpUrl(value) || "";
});
